module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO04LasMetas.aea9618.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO04LasMetas.mp4
// module id = 732
// module chunks = 1